var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6794 57.5794C44.5366 61.2422 38.2466 63.3994 31.4494 63.3994C14.0816 63.3994 -0.000640869 49.3172 -0.000640869 31.9494C-0.000640869 14.5816 14.0816 0.499367 31.4494 0.499367C48.8172 0.499367 62.8994 14.5816 62.8994 31.9494C62.8994 38.7464 60.7422 45.0364 57.0794 50.1794L77.744 70.844C79.779 72.879 79.7641 76.1388 77.744 78.1548L77.6589 78.2398C75.6462 80.2525 72.3641 80.26 70.3481 78.2398L49.6835 57.5752L49.6794 57.5794ZM31.4494 55.9994C44.7322 55.9994 55.4994 45.2322 55.4994 31.9494C55.4994 18.6666 44.7322 7.89943 31.4494 7.89943C18.1666 7.89943 7.39936 18.6666 7.39936 31.9494C7.39936 45.2322 18.1666 55.9994 31.4494 55.9994Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.0006,
    height: 80,
    fill: "white",
    transform: "translate(-0.000640869)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c23d2de329ea635b144dc3374f8f594f.svg";
export { ForwardRef as ReactComponent };